import React from "react";
import Blur from "../Blur";

export const BlurSpinner = ({ isLoading, children }) => (
  <>
    {isLoading ? (
      <div
        className="position-absolute d-flex justify-content-center align-content-center flex-wrap "
        style={{ zIndex: 999, width: "100%", height: "100%", top: 0, left: 0, backdropFilter: "blur(4px)" }}
      >
        <div className="loader-box">
          <div className="loader">
            <div className="line bg-danger" />
            <div className="line bg-danger" />
            <div className="line bg-danger" />
            <div className="line bg-danger" />
          </div>
        </div>
      </div>
    ) : (
      <></>
    )}
    <Blur radius={isLoading ? "5px" : "0"}>{children}</Blur>
  </>
);
